import React from 'react'

// material ui
import Container from '@mui/material/Container'

// components
import Loading from 'components/atoms/Loading'
import EditPersonHeader from 'components/shared/EditPersonHeader'
import Breadcrumbs from 'components/shared/Breadcrumbs'

// containers
import Form from 'components/account/PickupPeople/Form'

const EditPickupPerson = props => {
  const { pickupPerson, queryLoading, mutationLoading, account, season, form } =
    props

  return (
    <Container maxWidth='md'>
      <Breadcrumbs
        crumbs={[
          ['Account Overview', '/'],
          ['Pick-up People'],
          [pickupPerson ? pickupPerson.firstName : '…']
        ]}
      />
      <EditPersonHeader
        personType='Pick-up Person'
        person={pickupPerson}
        season={season}
        account={account}
      />
      {queryLoading || (!form?.id && !!pickupPerson) ? (
        <Loading />
      ) : (
        <Form
          buttonText={mutationLoading ? 'Saving…' : 'Save'}
          editMode
          showFormFields={!!pickupPerson}
          {...props}
        />
      )}
    </Container>
  )
}

export default EditPickupPerson
